__webpack_require__.p = "https://damdafayton.github.io/products-project-frontend/";